import { APIClient } from "api/api_helper";
import { Folder_API } from "api/url_helper";
import { GetUserData } from "common/service/CommonService";

interface CurrentUser {
  userid: number;
}

const api = new APIClient();

export const fileAttachmentApiService = {
    getFilesSelectAllData: (
        folderid: number,
        searchText?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,
    ) => {
        const payload = {
            fileid: null,
            folderid: folderid,
            searchtext: searchText || null,
            status: "A",
            currentpage: pageNumber,
            pagesize: pageSize,
        };
        return api.create(Folder_API.Folder_API + "FilesSelectAll", payload);
    },

    uploadFile: (payload_data: FormData) => {
        const user = GetUserData() as CurrentUser;
        payload_data.append("createdby", user.userid.toString());

        return api.create(Folder_API.Folder_API + "UploadFiles", payload_data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    deleteData: (payload_data: { fileid: number; updatereason: string }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            fileid: payload_data.fileid,
            updatedby: user.userid,
            updatereason: payload_data.updatereason,
        };
        return api.create(Folder_API.Folder_API + "FilesDelete", payload);
    },

    getParentFilesSelectAllData: (
        folderid: number,
        searchText?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,
    ) => {
        const payload = {
            folderid: folderid,
            searchtext: searchText || null,
            status: "A",
            pagenumber: pageNumber,
            pagesize: pageSize,
        };
        return api.create(Folder_API.Folder_API + "ParentSelectAll", payload);
    },
};